<form action="" class="grip w-full max-w-full pb-5" [formGroup]="form" (submit)="submit()">
  <div class="flex flex-col pb-2">
    <div class="flex flex-col gap-2 mb-4 mt-4">
      <label for="name"> {{ 'Name' | translate }} </label>
      <input formControlName="name" id="name" type="text" pInputText class="w-full" />
      <small class="block leading-6 text-xs">
        {{ 'Enter the name of the Folder.' | translate }} {{ 'Maximum characters:' | translate }} 25
      </small>
      <!-- <p-floatlabel>
        <input formControlName="locked" id="locked" type="checkbox" [value]="true" />
        <label for="locked"> {{ 'Lock' | translate }} </label>
      </p-floatlabel>
      @if(showPasswordForm) {
      <p-password
        #password
        id="password"
        styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full rounded-lg  mb-2"
        formControlName="password"
        placeholder="{{ 'Password' | translate }}"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }" />
      <p-password
        #confirm_password
        id="confirm_password"
        styleClass="p-password p-component p-inputwrapper p-input-icon-right w-full rounded-lg  mb-2"
        formControlName="confirm_password"
        placeholder="{{ 'Confirm password' | translate }}"
        [feedback]="false"
        [toggleMask]="true"
        [inputStyle]="{ width: '100%' }" />
      } -->
    </div>
  </div>

  <div class="flex flex-row-reverse flex-wrap pt-3">
    <div class="flex items-center justify-center">
      <p-button
        icon="pi pi-save"
        iconPos="left"
        type="submit"
        [styleClass]="'w-full'"
        label="{{ 'Save' | translate }}"
        [loading]="loading"
        [disabled]="form.invalid || loading"
        [rounded]="true" />
    </div>
  </div>
</form>
